
<template>
    <div>
        <el-row class="booking-set-left">
            <el-switch
                v-model="checkAll.isCheckSend"
                active-color="#ff4949"
                inactive-color="rgb(0, 128, 128)"
                active-text="หยุดส่ง "
                inactive-text=" จัดส่ง"
                :disabled="true">
            </el-switch>
        </el-row>
        <el-row>
            <div class="flex-container-Pich">
            <!-- <el-col v-for="(item,index) in courierBookingDataList" :key="index" :span="7" class="booking-set-cardbox"> -->
                <el-card v-for="(item,index) in courierBookingDataList" :key="index" shadow="never" class="box-card">
                    <div style="border-bottom:1px solid grey;align-items: center;" class="text-md-left">
                        <span>{{getCourier(item.courierId)}}</span>
                        <i class="material-icons" style="float: right;font-size: 20px;" @click="editBooking(item)">edit</i>
                    </div>
                    <el-row style="padding-top:10px;" class="text-md-left">
                        <el-col :span="24" :offset="2">
                            <span>รูปแบบการส่ง : {{ getShipflowTypeName(item.type) }}</span>
                        </el-col>
                    </el-row>
                    <el-row class="text-md-left">
                        <el-col :span="2">
                            <i class="el-icon-date"></i>
                        </el-col>
                        <el-col :span="22">
                            <span>เริ่มวันที่ : {{ item.startDate }} </span>
                        </el-col>
                    </el-row>
                    <el-row class="text-md-left">
                        <el-col :span="2">
                            <i class="el-icon-time"></i>
                        </el-col>
                        <el-col :span="22">
                            <span>{{ item.pickupTime }}</span>
                        </el-col>
                    </el-row>
                    <el-row class="text-md-left">
                        <el-col :span="22" :offset="2">
                            <span>{{formatPickUpAddress(item.pickupAddress)}}</span>
                        </el-col>
                    </el-row>
                    <el-row class="text-md-left">
                        <el-col :span="22" :offset="2">
                             <el-tag
                                v-for="(shop, idx) in item.shopNames"
                                :key="idx"
                                type="info"
                                style="margin: 5px 10px 5px 0px;"
                            >
                                {{ shop }}
                            </el-tag>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <el-row type="flex" align="middle" justify="center">
                        <el-button type="primary" @click="createBookingForm"><i class="el-icon-plus"></i>สร้าง</el-button>
                    </el-row>
                </el-card>
            </div>
            <!-- </el-col> -->
            <!-- <el-col :span="7" class="booking-set-cardbox">
                <el-card class="box-card" shadow="never">
                    <el-row type="flex" align="middle" justify="center">
                        <el-button type="primary" @click="createBookingForm"><i class="el-icon-plus"></i>สร้าง</el-button>
                    </el-row>
                </el-card>
            </el-col> -->
        </el-row>

        <booking-dialog-form :detail.sync="createBookingDetail"/>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import { eventBus } from '@/main'
import BookingDialogForm from '@/components/Booking/BookingDialog/BookingDialogForm.vue'

export default {
    name: 'BookingDelivery',
    components: {
        BookingDialogForm
    },
    props: {
        detail: {
            type: Object
        }
    },
    data () {
        return {
            isCheckStatusForm: {
                dialogBookingForm: false,
                textHeader: false
            },
            checkAll: {
                isCheckSend: true,
                dialogBooking: false,
                checkClickBooking: false
            },
            bookingAllData: {
                bookingCourier: '',
                deliveryForm: '',
                startAt: '',
                timeAt: '',
                addressDataForm: []
            },
            getAddressDataAll: null,
            // ------------------------
            courierBookingDataList: [],
            pickUpShopDetail: [],
            createBookingDetail: {
                isCheckEditBooking: false,
                isEditNameBooking: false,
                isSelectAddress: false,
                data: {}
            }
        }
    },
    created () {
        this.fetchAllCourierBooking()
        this.getPickUpAddressDetail()
        eventBus.$on('courierBookingCreateReload', () => {
            console.log('reload!!')
            this.createBookingDetail.isCheckEditBooking = false
            this.createBookingDetail.isEditNameBooking = false
            this.createBookingDetail.isSelectAddress = false
            this.createBookingDetail.data = {}
            this.fetchAllCourierBooking()
            this.getPickUpAddressDetail()
        })
    },
    methods: {
        async fetchAllCourierBooking () {
            console.log('detail', this.detail)
            let param = {
                user_id: this.detail.data.userId
            }
            try {
                let res = await fgApi.courier.getAllCourierBooking(param)
                console.log('res', res)
                if (res.success) {
                    this.courierBookingDataList = res.data
                }
            } catch (error) {
                console.error(error)
            }
        },
        async getPickUpAddressDetail () {
            let param = {
                user_id: this.detail.data.userId
            }
            try {
                let res = await fgApi.user.getAllPickupAddressShop(param)
                console.log('Pick up', res)
                if (res.success) {
                    this.pickUpShopDetail = res.data
                }
            } catch (error) {
                console.error(error)
            }
        },
        editBooking (data) {
            console.log(data)
            this.createBookingDetail.isCheckEditBooking = true
            this.createBookingDetail.isEditNameBooking = true
            this.createBookingDetail.data = { ...data }
            this.createBookingDetail.data.userCode = this.detail.data.userCode
            this.createBookingDetail.data.userId = this.detail.data.userId
        },
        formatPickUpAddress (addressObj) {
            if (addressObj.province === 'กรุงเทพมหานคร') {
                return `${addressObj.address} แขวง${addressObj.subDistrict} เขต${addressObj.district} ${addressObj.province} ${addressObj.zipcode}`
            } else {
                return `${addressObj.address} ต.${addressObj.subDistrict} อ.${addressObj.district} จ.${addressObj.province} ${addressObj.zipcode}`
            }
        },
        handleClose (done) {
            this.$confirm('Are you sure to close this dialog?')
                .then(_ => {
                    done()
                })
                .catch(_ => {})
        },
        createBookingForm () {
            this.createBookingDetail.data.userId = this.detail.data.userId
            this.createBookingDetail.data.userCode = this.detail.data.userCode
            this.createBookingDetail.isCheckEditBooking = true
        },
        editBookingForm () {
            this.checkAll.dialogBooking = true
            this.checkAll.checkClickBooking = true
        }
    }
}
</script>

<style lang="scss" scoped>
    .flex-container-Pich {
        display: flex;
        flex-wrap: wrap;
        .box-card {
            width: 30%;
            min-height: 300px;
            margin: 10px;
            line-height: 2.2;
        }
    }
    .text {
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }
    .booking-set-left{
        text-align: left;
        padding-bottom: 20px;
    }
    .booking-set-cardbox{
        margin: 10px 10px;
        text-align: left;
        font-size: 14px;
        line-height: 30px;
    }
    .book-dialog-header {
        padding: 0px !important;
        padding-bottom: 0px !important;
        .dialog-btn-delete{
            text-align: right;
            padding-bottom: 20px;
        }
        .d-font-icon{
            font-size: 25px;
        }
    }

</style>
